export const appName = "Intimex";
